import { withValidity } from './validity-query';
import type { ErrorEnvelope } from '@mori/contracts';

export class ApiError extends Error { constructor(message: string, readonly status: number, readonly body?: ErrorEnvelope) { super(message); } }

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof FormData)) headers.set('Content-Type', 'application/json');
  const response = await fetch(`/api${path}`, { ...options, headers, credentials: 'include' });
  if (response.status === 401 && !path.startsWith('/auth/')) window.dispatchEvent(new Event('eam-session-expired'));
  if (!response.ok) { let body: ErrorEnvelope | undefined; try { body = await response.json(); } catch { body = undefined; } throw new ApiError(body?.message || `请求失败 (${response.status})`, response.status, body); }
  if (options.method && !['GET', 'HEAD'].includes(options.method)) window.dispatchEvent(new Event('eam-business-changed'));
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}

export const listApi = <T>(path: string) => api<T>(withValidity(path));

export const post = <T>(path: string, body?: unknown) => api<T>(path, { method: 'POST', body: body === undefined ? undefined : JSON.stringify(body) });
export const patch = <T>(path: string, body: unknown) => api<T>(path, { method: 'PATCH', body: JSON.stringify(body) });
export const remove = <T>(path: string) => api<T>(path, { method: 'DELETE' });

export async function download(path: string, fallbackName: string) {
  const response = await fetch(`/api${path.startsWith('/exports/') ? withValidity(path) : path}`, { credentials: 'include' });
  if (!response.ok) throw new ApiError('下载失败', response.status);
  const disposition = response.headers.get('content-disposition') || '';
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition)?.[1];
  const href = URL.createObjectURL(await response.blob());
  const anchor = document.createElement('a'); anchor.href = href; anchor.download = encoded ? decodeURIComponent(encoded) : fallbackName; anchor.click(); URL.revokeObjectURL(href);
}

